import { IFormattedCashFlowPeriod } from 'views/ProFormaTable/types';
import { formatPeriodHeader } from '../helpers';

export interface PeriodHeaderCellsProps {
    periodColumns: IFormattedCashFlowPeriod[];
}

const PeriodHeaderCells = ({ periodColumns }: PeriodHeaderCellsProps) => (
    <>
        {periodColumns.map(column => (
            <th
                key={column.value}
                className="NSTable__thead__tr__th align-middle NSTable__thead__tr__th--grey-bg NSTable__thead__tr__th--width-150 py-1"
            >
                <div className="h6 NSTable__thead__tr__th--grey-text text-uppercase text-nowrap text-right mb-0">{formatPeriodHeader(column.period)}</div>
                <div className="h6 text-uppercase text-right text-nowrap mt-1">{column.label}</div>
            </th>
        ))}
    </>
);

export default PeriodHeaderCells;
